window.CMTheme = {
  announce(message) {
    const region = document.querySelector('[data-live-region]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => { region.textContent = message; }, 50);
  },
  money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-disclosure-trigger]');
  if (!trigger) return;
  const panel = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!panel) return;
  const open = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!open));
  panel.hidden = open;
});

document.querySelectorAll('[data-mega-menu]').forEach((menu) => {
  const trigger = menu.querySelector('[data-mega-trigger]');
  const panel = menu.querySelector('[data-mega-panel]');
  if (!trigger || !panel) return;
  const open = () => {
    document.querySelectorAll('[data-mega-menu].is-open').forEach((other) => {
      if (other === menu) return;
      other.classList.remove('is-open');
      other.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      other.querySelector('[data-mega-panel]')?.setAttribute('aria-hidden', 'true');
    });
    menu.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  };
  const close = () => {
    menu.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  };
  menu.addEventListener('mouseenter', open);
  menu.addEventListener('mouseleave', close);
  trigger.addEventListener('focus', open);
  trigger.addEventListener('click', () => menu.classList.contains('is-open') ? close() : open());
  menu.addEventListener('focusout', (event) => { if (!menu.contains(event.relatedTarget)) close(); });
  menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); trigger.focus(); } });
});
